// Malayalam. Recipe text itself stays in English for Malayalam readers (recipes are written in
// Tamil, English and Tanglish), so search examples use English words.
import type { Key } from '../i18n';

export const ml: Record<Key, string> = {
  'nav.main': 'പ്രധാനം',
  'nav.home': 'ഹോം',
  'nav.albums': 'ആൽബങ്ങൾ',
  'nav.grocery': 'പലചരക്ക്',
  'nav.home.label': 'Eat Recipe ഹോം',
  'common.tryAgain': 'വീണ്ടും ശ്രമിക്കുക',
  'common.tryingAgain': 'വീണ്ടും ശ്രമിക്കുന്നു…',
  'common.back': 'പിന്നോട്ട്',
  'common.cancel': 'റദ്ദാക്കുക',
  'common.save': 'സേവ് ചെയ്യുക',
  'common.done': 'കഴിഞ്ഞു',
  'common.loading': 'ലോഡ് ചെയ്യുന്നു',
  'common.seeAll': 'എല്ലാം കാണുക',
  'common.addReel': 'റീൽ ചേർക്കുക',
  'common.profile': 'ക്രമീകരണങ്ങൾ, പ്രൊഫൈൽ',
  'common.watchReel': 'റീൽ കാണുക ↗',
  'common.veg': 'വെജ്',
  'common.nonveg': 'നോൺ-വെജ്',
  'common.unsure': 'ഉറപ്പില്ല',
  'n.recipes_one': '{n} പാചകക്കുറിപ്പ്',
  'n.recipes': '{n} പാചകക്കുറിപ്പുകൾ',
  'n.ingredients_one': '{n} ചേരുവ',
  'n.ingredients': '{n} ചേരുവകൾ',
  'n.steps_one': '{n} ഘട്ടം',
  'n.steps': '{n} ഘട്ടങ്ങൾ',
  'n.cooked': '{n}× ഉണ്ടാക്കി',
  'n.cookedOn': '{n}× ഉണ്ടാക്കി · {date}',
  'verdict.again': 'വീണ്ടും ഉണ്ടാക്കും',
  'verdict.ok': 'കുഴപ്പമില്ല',
  'verdict.no': 'ഞങ്ങൾക്ക് പറ്റിയില്ല',

  'lang.title': 'നിങ്ങളുടെ ഭാഷ തിരഞ്ഞെടുക്കുക',
  'lang.body': 'ആപ്പിലെ വാക്കുകളും Instagram ബോട്ടിന്റെ മറുപടികളും ഈ ഭാഷയിലായിരിക്കും. ക്രമീകരണങ്ങളിൽ എപ്പോൾ വേണമെങ്കിലും മാറ്റാം.',
  'lang.ta': 'പാചകക്കുറിപ്പുകളും ആപ്പും തമിഴിൽ',
  'lang.en': 'പാചകക്കുറിപ്പുകളും ആപ്പും ഇംഗ്ലീഷിൽ',
  'lang.tg': 'thakkali, vengayam പോലുള്ള പേരുകൾ · ആപ്പ് ഇംഗ്ലീഷിൽ',
  'lang.continue': 'തുടരുക',
  'lang.saveFailed': 'നിങ്ങളുടെ ഭാഷ സേവ് ചെയ്യാനായില്ല. കണക്ഷൻ പരിശോധിച്ച് വീണ്ടും ശ്രമിക്കുക.',

  'greet.tiffin': 'സുപ്രഭാതം{name} · പ്രാതൽ സമയം',
  'greet.lunch': 'നമസ്കാരം{name} · ഉച്ചഭക്ഷണ സമയം',
  'greet.teatime': 'ശുഭ സായാഹ്നം{name} · ചായ സമയം',
  'greet.dinner': 'ശുഭ സായാഹ്നം{name} · അത്താഴ സമയം',
  'greet.latenight': 'രാത്രി വൈകി{name} · പെട്ടെന്ന് എന്തെങ്കിലും?',
  'home.title': 'ഇന്ന് എന്ത് കഴിക്കാനാണ് തോന്നുന്നത്?',
  'home.search': '{n} പാചകക്കുറിപ്പുകളിൽ തിരയുക · tomato · rasam',
  'home.searchEmpty': 'തിരയുക · tomato · rasam',
  'home.mood': 'മൂഡ് അനുസരിച്ച്',
  'home.surprise': 'തീരുമാനിക്കാൻ പറ്റുന്നില്ലേ? എന്തെങ്കിലും നിർദ്ദേശിക്കൂ',
  'home.howAbout': 'ഇതെങ്ങനെ…',
  'home.cookThis': 'ഇത് ഉണ്ടാക്കാം',
  'home.another': 'മറ്റൊന്ന്',
  'home.cookAgain': 'വീണ്ടും ഉണ്ടാക്കൂ',
  'home.cookAgainHint': 'നിങ്ങൾ “വീണ്ടും ഉണ്ടാക്കും” എന്ന് പറഞ്ഞു',
  'home.yourAlbums': 'നിങ്ങളുടെ ആൽബങ്ങൾ',
  'home.justSaved': 'ഇപ്പോൾ സേവ് ചെയ്തവ',
  'home.allByDate': 'തീയതി അനുസരിച്ച് എല്ലാം',
  'home.readingFrom': '{who} യുടെ റീൽ വായിക്കുന്നു',
  'home.reading': 'റീൽ വായിക്കുന്നു',
  'home.landsInAlbums': 'തയ്യാറാകുമ്പോൾ ശരിയായ ആൽബങ്ങളിൽ എത്തും',
  'home.addedTo': '{albums} ൽ ചേർത്തു',
  'home.noRecipe': 'ഈ റീലിൽ പാചകക്കുറിപ്പ് കണ്ടെത്തിയില്ല',
  'home.failed': 'ഈ റീൽ വായിക്കാനായില്ല · വീണ്ടും ശ്രമിക്കാൻ ടാപ്പ് ചെയ്യുക',
  'home.newTitle': 'നിങ്ങളുടെ പാചകക്കുറിപ്പുകൾ ഇവിടെ, മൂഡ് അനുസരിച്ച് അടുക്കി എത്തും',
  'home.newBody': 'Instagram-ൽ ഏത് പാചക റീലിലും ➤ ടാപ്പ് ചെയ്ത് @eat.recipe ലേക്ക് അയയ്ക്കുക. ഒരു മിനിറ്റിനുള്ളിൽ പാചകക്കുറിപ്പ് ഇവിടെയുണ്ടാകും.',
  'home.openInstagram': '@eat.recipe ന് മെസേജ് ചെയ്യുക',
  'home.pasteLink': 'പകരം റീൽ ലിങ്ക് പേസ്റ്റ് ചെയ്യുക',
  'reason.never_tried': 'സേവ് ചെയ്തു, ഒരിക്കലും ഉണ്ടാക്കിയില്ല',
  'reason.make_again_days': 'വീണ്ടും ഉണ്ടാക്കും എന്ന് പറഞ്ഞു · {n} ദിവസം മുമ്പ്',
  'reason.make_again_weeks': 'വീണ്ടും ഉണ്ടാക്കും എന്ന് പറഞ്ഞു · {n} ആഴ്ച മുമ്പ്',
  'reason.not_cooked_days': '{n} ദിവസമായി ഉണ്ടാക്കിയില്ല',
  'reason.not_cooked_weeks': '{n} ആഴ്ചയായി ഉണ്ടാക്കിയില്ല',
  'reason.meal.tiffin': 'പ്രാതലിന് നല്ലത്',
  'reason.meal.lunch': 'ഉച്ചഭക്ഷണത്തിന് നല്ലത്',
  'reason.meal.teatime': 'ചായയോടൊപ്പം നല്ലത്',
  'reason.meal.dinner': 'അത്താഴത്തിന് നല്ലത്',
  'reason.meal.latenight': 'രാത്രി വൈകി പെട്ടെന്ന്',
  'surprise.none': 'ഇവിടെ നിർദ്ദേശിക്കാൻ ഇതുവരെ ഒന്നുമില്ല.',

  'albums.title': 'ആൽബങ്ങൾ',
  'albums.sub': '{n} പാചകക്കുറിപ്പുകൾ, വരുമ്പോൾ തന്നെ നിങ്ങൾക്കായി അടുക്കിയത്',
  'albums.sub_one': '1 പാചകക്കുറിപ്പ്, വരുമ്പോൾ തന്നെ നിങ്ങൾക്കായി അടുക്കിയത്',
  'albums.search': 'എല്ലാ പാചകക്കുറിപ്പുകളിലും തിരയുക',
  'albums.mine': 'നിങ്ങൾ ഉണ്ടാക്കിയവ',
  'albums.new': 'പുതിയ ആൽബം',
  'albums.browse': 'ഇങ്ങനെ കാണുക',
  'albums.view': 'ആൽബം കാഴ്ച',
  'view.craving': 'മൂഡ്',
  'view.region': 'പ്രദേശം',
  'view.meal': 'ഭക്ഷണം',
  'view.timeline': 'ടൈംലൈൻ',
  'hint.craving': 'മൂഡ് അനുസരിച്ച് തിരഞ്ഞെടുക്കൂ — എരിവുള്ളത്, ആശ്വാസം, പെട്ടെന്നുള്ളത് അല്ലെങ്കിൽ ലഘുവായത്.',
  'hint.region': 'ഒരു നാടിന്റെ രുചി — ചെട്ടിനാട് അടുക്കളകൾ മുതൽ ലോക വിഭവങ്ങൾ വരെ.',
  'hint.meal': 'ഇപ്പോൾ ഏത് സമയം? പ്രാതൽ മുതൽ അത്താഴം വരെ, ലഞ്ച്ബോക്സും.',
  'hint.timeline': 'നിങ്ങൾ പങ്കിട്ട ഓരോ റീലും, സേവ് ചെയ്ത ക്രമത്തിൽ.',
  'albums.empty': 'ഇവിടെ ഇതുവരെ ഒന്നുമില്ല. @eat.recipe ലേക്ക് കുറച്ച് റീലുകൾ അയയ്ക്കൂ, അവ സ്വയം ആൽബങ്ങളിലേക്ക് അടുങ്ങും.',
  'tl.week': 'ഈ ആഴ്ച',
  'tl.month_rest': 'ഈ മാസം നേരത്തെ',
  'tl.before': 'അതിനു മുമ്പ്',
  'tl.reading': '{n} വായിക്കുന്നു…',

  'kind.craving': 'മൂഡ്',
  'kind.region': 'പ്രദേശം',
  'kind.meal': 'ഭക്ഷണം',
  'kind.mine': 'നിങ്ങളുടെ ആൽബം',
  'album.stats': '{n} പാചകക്കുറിപ്പുകൾ · {c} ഉണ്ടാക്കി · {u} ഇതുവരെ ശ്രമിച്ചിട്ടില്ല',
  'album.stats_one': '1 പാചകക്കുറിപ്പ് · {c} ഉണ്ടാക്കി · {u} ഇതുവരെ ശ്രമിച്ചിട്ടില്ല',
  'album.pin': 'ഹോമിൽ പിൻ ചെയ്യുക',
  'album.unpin': 'ഹോമിൽ നിന്ന് മാറ്റുക',
  'album.pinned': 'ഹോമിൽ പിൻ ചെയ്തു',
  'album.unpinned': 'ഹോമിൽ നിന്ന് മാറ്റി',
  'album.backToAlbums': 'ആൽബങ്ങളിലേക്ക് മടങ്ങുക',
  'filter.label': 'പാചകക്കുറിപ്പുകൾ ഫിൽട്ടർ ചെയ്യുക',
  'filter.all': 'എല്ലാം',
  'filter.untried': 'ഇതുവരെ ശ്രമിച്ചിട്ടില്ല',
  'album.pick': 'ഇതിൽ നിന്ന് എനിക്കായി ഒന്ന് തിരഞ്ഞെടുക്കൂ',
  'album.favourites': 'നിങ്ങളുടെ പ്രിയപ്പെട്ടവ',
  'album.notTried': 'ഇതുവരെ ശ്രമിച്ചിട്ടില്ല',
  'album.cookedBefore': 'മുമ്പ് ഉണ്ടാക്കിയവ',
  'album.saved': '{date} ന് സേവ് ചെയ്തു',
  'album.shop': 'ഇവയിൽ ചിലതിനായി വാങ്ങുക',
  'album.shopTitle': 'ഏതൊക്കെയാണ് നിങ്ങൾ ഉണ്ടാക്കുന്നത്?',
  'album.shopGo': 'പലചരക്ക് ലിസ്റ്റ് ഉണ്ടാക്കുക · {n}',
  'album.empty': 'ഇവിടെ ഇതുവരെ പാചകക്കുറിപ്പുകളില്ല.',
  'album.emptyMine': 'ഒരു പാചകക്കുറിപ്പ് തുറന്ന് “ആൽബത്തിൽ ചേർക്കുക” ടാപ്പ് ചെയ്യുക.',
  'album.noMatch': 'ഈ ഫിൽട്ടറിന് ഒന്നും യോജിക്കുന്നില്ല.',
  'album.showAll': 'എല്ലാം കാണിക്കുക',
  'album.rename': 'പേര് മാറ്റുക',
  'album.delete': 'ആൽബം ഇല്ലാതാക്കുക',
  'album.deleteConfirm': 'ഇല്ലാതാക്കാൻ വീണ്ടും ടാപ്പ് ചെയ്യുക — പാചകക്കുറിപ്പുകൾ നിങ്ങളുടെ ലൈബ്രറിയിൽ തന്നെ ഉണ്ടാകും',
  'album.notFound': 'ഈ ആൽബം ഇപ്പോൾ നിലവിലില്ല.',
  'album.nameLabel': 'ആൽബത്തിന്റെ പേര്',
  'album.namePlaceholder': 'അമ്മയുടെ രീതി · ഞായറാഴ്ച സ്പെഷ്യൽ',
  'album.create': 'ആൽബം ഉണ്ടാക്കുക',
  'album.created': 'ആൽബം ഉണ്ടാക്കി',

  'timeline.title': 'തീയതി അനുസരിച്ച് എല്ലാം',
  'timeline.newest': 'പുതിയവ ആദ്യം',
  'timeline.search': 'പാചകക്കുറിപ്പുകൾ തിരയുക',
  'timeline.empty': 'നിങ്ങളുടെ ലൈബ്രറി ശൂന്യമാണ്',
  'timeline.emptyBody': 'Instagram-ൽ ഏത് പാചക റീലിലും ➤ ടാപ്പ് ചെയ്ത് @eat.recipe ലേക്ക് അയയ്ക്കുക. നിമിഷങ്ങൾക്കുള്ളിൽ പാചകക്കുറിപ്പ് ഇവിടെ കാണാം.',
  'timeline.noMatch': 'ഈ ഫിൽട്ടറിന് ഒന്നും യോജിക്കുന്നില്ല.',
  'timeline.showAll': 'എല്ലാം കാണിക്കുക',
  'timeline.retrying': 'വീണ്ടും ശ്രമിക്കുന്നു — പാചകക്കുറിപ്പ് ഇവിടെ വരും',
  'timeline.scriptHint': 'പേരുകൾ {script}-ൽ; മാറ്റാൻ ടാപ്പ് ചെയ്യുക',

  'card.reading': 'റീൽ വായിക്കുന്നു',
  'card.arrives': 'പാചകക്കുറിപ്പ് നിമിഷങ്ങൾക്കുള്ളിൽ എത്തും',
  'card.progress': 'പ്രോസസ്സിംഗ് പുരോഗതി',
  'card.stages': 'കിട്ടി · കേൾക്കുന്നു · എഴുതുന്നു',
  'card.failed': 'ഈ റീൽ വായിക്കാനായില്ല',
  'card.linkSafe': 'നിങ്ങളുടെ ലിങ്ക് സുരക്ഷിതമാണ്.',
  'card.private': 'റീൽ സ്വകാര്യമാണ് അല്ലെങ്കിൽ നീക്കം ചെയ്തു.',
  'card.dropped': 'കേൾക്കുന്നതിനിടെ കണക്ഷൻ മുറിഞ്ഞു.',
  'card.wrong': 'കേൾക്കുന്നതിനിടെ എന്തോ പിഴവ് സംഭവിച്ചു.',
  'card.noRecipe': 'ഈ റീലിൽ പാചകക്കുറിപ്പില്ല',
  'card.noRecipeBody': 'ഇതിൽ ഒരു വിഭവത്തെക്കുറിച്ച് സംസാരിക്കുന്നു, പക്ഷേ ഉണ്ടാക്കുന്ന വിധം കാണിക്കുന്നില്ല. ലിങ്ക് നിങ്ങൾക്കായി സൂക്ഷിച്ചു.',
  'card.ingredientsOnly': 'ചേരുവകൾ മാത്രം — റീലിൽ ഘട്ടങ്ങൾ പറഞ്ഞിട്ടില്ല',
  'card.taVoice': 'തമിഴ് ശബ്ദം',
  'card.enVoice': 'ഇംഗ്ലീഷ് ശബ്ദം',

  'add.title': 'റീൽ ചേർക്കുക',
  'add.label': 'Instagram റീൽ ലിങ്ക് പേസ്റ്റ് ചെയ്യുക',
  'add.adding': 'ചേർക്കുന്നു…',
  'add.submit': 'എന്റെ ലൈബ്രറിയിൽ ചേർക്കുക',
  'add.or': 'അല്ലെങ്കിൽ, Instagram-ൽ ഏത് റീലും ഇങ്ങോട്ട് ഷെയർ ചെയ്യുക',
  'add.added': 'കിട്ടി — റീൽ വായിക്കുന്നു',

  'search.label': 'പാചകക്കുറിപ്പുകൾ തിരയുക',
  'search.back': 'പിന്നോട്ട്',
  'search.clear': 'തിരയൽ മായ്ക്കുക',
  'search.also': 'ഇവയും തിരയുന്നു',
  'search.count_one': '1 പാചകക്കുറിപ്പ്',
  'search.count': '{n} പാചകക്കുറിപ്പുകൾ',
  'search.idle': 'വിഭവം, ചേരുവ അല്ലെങ്കിൽ ക്രിയേറ്റർ പേരിൽ തിരയുക.',
  'search.none': 'ഒന്നും കിട്ടിയില്ലേ?',
  'search.tryScripts': 'ഇംഗ്ലീഷ് വാക്കുകൾ കൊണ്ട് തിരയുക — ഉദാ. tomato അല്ലെങ്കിൽ rasam. പാചകക്കുറിപ്പുകൾ തമിഴ്, ഇംഗ്ലീഷ്, Tanglish എന്നിവയിൽ എഴുതുന്നു.',
  'match.dish': 'വിഭവത്തിന്റെ പേര് യോജിച്ചു',
  'match.ingredient': 'ചേരുവ:',
  'match.transcript': 'റീലിൽ പറഞ്ഞത്:',
  'match.caption': 'ക്യാപ്ഷൻ:',
  'match.tag': '“{t}” ടാഗ്',
  'match.creator': '{t} ൽ നിന്ന്',
  'match.similar': 'സമാനമായ അക്ഷരവിന്യാസം',

  'recipe.notInLibrary': 'ഈ പാചകക്കുറിപ്പ് നിങ്ങളുടെ ലൈബ്രറിയിൽ ഇല്ല.',
  'recipe.share': 'പാചകക്കുറിപ്പ് ഷെയർ ചെയ്യുക',
  'recipe.copied': 'ലിങ്ക് കോപ്പി ചെയ്തു',
  'recipe.reelLength': '{d} റീൽ',
  'recipe.taVoice': 'തമിഴ് ശബ്ദം',
  'recipe.enVoice': 'ഇംഗ്ലീഷ് ശബ്ദം',
  'recipe.cookedLast': '{n}× ഉണ്ടാക്കി · അവസാനം {date}',
  'recipe.today': 'ഇന്ന്',
  'recipe.from': 'ഈ റീലിൽ നിന്നുള്ള പാചകക്കുറിപ്പ്:',
  'recipe.cookMode': 'കുക്ക് മോഡ്',
  'recipe.addGrocery': 'പലചരക്ക് ലിസ്റ്റിൽ ചേർക്കുക',
  'recipe.inGrocery': 'നിങ്ങളുടെ പലചരക്ക് ലിസ്റ്റിലുണ്ട് ✓',
  'recipe.groceryAdded': 'പലചരക്ക് ലിസ്റ്റിൽ ചേർത്തു',
  'recipe.groceryRemoved': 'പലചരക്ക് ലിസ്റ്റിൽ നിന്ന് മാറ്റി',
  'swipe.add': 'പലചരക്കിൽ ചേർക്കുക',
  'swipe.remove': 'പലചരക്കിൽ നിന്ന് നീക്കുക',
  'grocery.swipeHint': 'സൂചന: ഒരു റെസിപ്പി വലത്തേക്ക് സ്വൈപ്പ് ചെയ്താൽ ഇവിടെ ചേരും.',
  'recipe.playReel': 'റീൽ ഇവിടെ പ്ലേ ചെയ്യുക',
  'recipe.fullScreen': 'ഫുൾ സ്ക്രീൻ',
  'recipe.closeReel': 'റീൽ അടയ്ക്കുക',
  'recipe.addAlbum': 'ആൽബത്തിൽ ചേർക്കുക',
  'recipe.inAlbums_one': '1 ആൽബത്തിൽ',
  'recipe.inAlbums': '{n} ആൽബങ്ങളിൽ',
  'recipe.script': 'പാചകക്കുറിപ്പിന്റെ ലിപി',
  'recipe.ingredients': 'ചേരുവകൾ',
  'recipe.inHand': '{total} ൽ {n} കൈയിലുണ്ട്',
  'recipe.steps': 'തയ്യാറാക്കുന്ന വിധം',
  'recipe.tgSteps': 'ഘട്ടങ്ങൾ ഇംഗ്ലീഷിലും തമിഴിലും മാത്രം — ഇംഗ്ലീഷ് കാണിക്കുന്നു.',
  'recipe.noSteps': 'റീലിൽ ഘട്ടങ്ങൾ പറഞ്ഞിട്ടില്ല — രീതിക്കായി റീൽ കാണുക.',
  'recipe.caption': 'ക്രിയേറ്ററുടെ ക്യാപ്ഷൻ',
  'recipe.says': 'റീലിൽ പറയുന്നത്',
  'recipe.rough': 'റീലിൽ നിന്ന് സ്വയം എഴുതിയത്; ചിലയിടങ്ങളിൽ കൃത്യമല്ലാതിരിക്കാം.',
  'recipe.noRecipe': 'ഈ റീലിൽ പാചകക്കുറിപ്പ് കണ്ടെത്തിയില്ല.',
  'recipe.readingTitle': 'പാചകക്കുറിപ്പ് നിമിഷങ്ങൾക്കുള്ളിൽ ഇവിടെ വരും',
  'recipe.failedBody': 'നിങ്ങളുടെ ലിങ്ക് സുരക്ഷിതമാണ്. വീണ്ടും ശ്രമിച്ചാൽ സാധാരണ ശരിയാകും.',
  'recipe.remove': 'എന്റെ ലൈബ്രറിയിൽ നിന്ന് മാറ്റുക',
  'recipe.removeConfirm': 'മാറ്റാൻ വീണ്ടും ടാപ്പ് ചെയ്യുക',
  'recipe.removeNote': 'ഈ പാചകക്കുറിപ്പിനുള്ള നിങ്ങളുടെ കുറിപ്പുകളും ഇല്ലാതാകും.',
  'recipe.removeKeep': 'ഇത് സേവ് ചെയ്ത മറ്റുള്ളവർക്ക് പാചകക്കുറിപ്പ് ലഭ്യമായിരിക്കും.',
  'albumSheet.title': 'ആൽബത്തിൽ ചേർക്കുക',
  'albumSheet.none': 'നിങ്ങൾ ഇതുവരെ ആൽബം ഉണ്ടാക്കിയിട്ടില്ല.',
  'albumSheet.added': '{name} ൽ ചേർത്തു',
  'albumSheet.removed': '{name} ൽ നിന്ന് മാറ്റി',
  'notes.title': 'എന്റെ അടുക്കള കുറിപ്പുകൾ',
  'notes.private': 'നിങ്ങൾക്ക് മാത്രം',
  'notes.cookedToday': 'ഇന്ന് ഉണ്ടാക്കി ✓',
  'notes.cookToday': 'ഞാൻ ഇന്ന് ഇത് ഉണ്ടാക്കി',
  'notes.logged_one': 'രേഖപ്പെടുത്തി · ആകെ 1 തവണ · പിൻവലിക്കാൻ വീണ്ടും ടാപ്പ് ചെയ്യുക',
  'notes.logged': 'രേഖപ്പെടുത്തി · ആകെ {n} തവണ · പിൻവലിക്കാൻ വീണ്ടും ടാപ്പ് ചെയ്യുക',
  'notes.cookedBefore_one': 'ഒരിക്കൽ ഉണ്ടാക്കി · അവസാനം {date}',
  'notes.cookedBefore': '{n} തവണ ഉണ്ടാക്കി · അവസാനം {date}',
  'notes.notYet': 'ഇതുവരെ ഉണ്ടാക്കിയില്ല',
  'notes.turnOut': 'എങ്ങനെയുണ്ടായിരുന്നു?',
  'notes.next': 'അടുത്ത തവണത്തേക്കുള്ള കുറിപ്പ്',
  'notes.placeholder': 'മുളക് കുറവ്, ഒരു തക്കാളി കൂടി…',
  'notes.save': 'കുറിപ്പ് സേവ് ചെയ്യുക',
  'notes.delete': 'കുറിപ്പ് ഇല്ലാതാക്കുക',
  'notes.today': 'ഇന്ന്',

  'cook.exit': 'പുറത്തുകടക്കുക',
  'cook.awake': 'സ്ക്രീൻ ഓണായിരിക്കും',
  'cook.keepOn': 'സ്ക്രീൻ ഓണാക്കി വയ്ക്കുക',
  'cook.switch': 'ഘട്ടങ്ങളുടെ ഭാഷ മാറ്റുക',
  'cook.progress': 'ഘട്ടങ്ങളുടെ പുരോഗതി',
  'cook.step': 'ഘട്ടം',
  'cook.forStep': 'ഈ ഘട്ടത്തിന് വേണ്ടത്',
  'cook.prev': 'മുമ്പത്തെ ഘട്ടം',
  'cook.next': 'അടുത്ത ഘട്ടം',
  'cook.noSteps': 'ഈ പാചകക്കുറിപ്പിൽ ഒപ്പം ഉണ്ടാക്കാൻ ഘട്ടങ്ങളില്ല.',
  'cook.backToRecipe': 'പാചകക്കുറിപ്പിലേക്ക് മടങ്ങുക',

  'grocery.title': 'പലചരക്ക് ലിസ്റ്റ്',
  'grocery.summary': '{n} സാധനങ്ങൾ · {b} സഞ്ചിയിൽ · {r} പാചകക്കുറിപ്പുകളിൽ നിന്ന്',
  'grocery.summary_one': '{n} സാധനങ്ങൾ · {b} സഞ്ചിയിൽ · 1 പാചകക്കുറിപ്പിൽ നിന്ന്',
  'grocery.addRecipes': '+ പാചകക്കുറിപ്പുകൾ',
  'grocery.emptyTitle': 'ഇതുവരെ വാങ്ങാൻ ഒന്നുമില്ല',
  'grocery.emptyBody': 'ഒരു പാചകക്കുറിപ്പ് തുറന്ന് “പലചരക്ക് ലിസ്റ്റിൽ ചേർക്കുക” ടാപ്പ് ചെയ്യുക. വ്യത്യസ്ത പാചകക്കുറിപ്പുകളിലെ ഒരേ ചേരുവ ഒരു വരിയായി ചേരും.',
  'grocery.bringBack': '{n} പാചകക്കുറിപ്പുകൾ തിരികെ കൊണ്ടുവരിക',
  'grocery.bringBack_one': '1 പാചകക്കുറിപ്പ് തിരികെ കൊണ്ടുവരിക',
  'grocery.goRecipes': 'എന്റെ പാചകക്കുറിപ്പുകളിലേക്ക് പോകുക',
  'grocery.remove': '{dish} മാറ്റുക',
  'grocery.skipped': '{n} പാചകക്കുറിപ്പുകൾക്ക് ഇതുവരെ ചേരുവ ലിസ്റ്റില്ല.',
  'grocery.skipped_one': '1 പാചകക്കുറിപ്പിന് ഇതുവരെ ചേരുവ ലിസ്റ്റില്ല.',
  'grocery.hidePantry': 'വീട്ടിലുള്ള സാധാരണ സാധനങ്ങൾ മറയ്ക്കുക',
  'grocery.hidden': '{n} മറച്ചു: {names}',
  'grocery.nothingHidden': 'മറയ്ക്കാൻ ഒന്നുമില്ല',
  'grocery.showingBasics': 'ഉപ്പ്, എണ്ണ തുടങ്ങിയ സാധാരണ സാധനങ്ങൾ കാണിക്കുന്നു',
  'grocery.vegetables': 'പച്ചക്കറികൾ',
  'grocery.spices': 'മസാലകൾ',
  'grocery.others': 'മറ്റുള്ളവ',
  'grocery.nRecipes': '{n} പാചകക്കുറിപ്പുകൾ',
  'grocery.asNeeded': 'ആവശ്യത്തിന്',
  'grocery.copy': 'ലിസ്റ്റ് കോപ്പി ചെയ്യുക',
  'grocery.copied': 'കോപ്പി ചെയ്തു — എവിടെയും പേസ്റ്റ് ചെയ്യാം',
  'grocery.copyFailed': 'ഈ ഉപകരണത്തിൽ കോപ്പി ചെയ്യാനായില്ല',
  'grocery.whatsapp': 'WhatsApp-ൽ ഷെയർ ചെയ്യുക',
  'grocery.later': 'പലചരക്ക് ആപ്പിൽ നിന്ന് ഓർഡർ — ഉടൻ വരുന്നു',
  'grocery.textTitle': 'പലചരക്ക് ലിസ്റ്റ് — Eat Recipe',

  'settings.title': 'ക്രമീകരണങ്ങൾ',
  'settings.account': 'നിങ്ങളുടെ അക്കൗണ്ട്',
  'settings.via': 'Instagram DM വഴി സൈൻ ഇൻ',
  'settings.language': 'ഭാഷ',
  'settings.languageHint': 'ആപ്പും ബോട്ടിന്റെ മറുപടികളും. പാചകക്കുറിപ്പുകൾ ഇംഗ്ലീഷിൽ കാണിക്കും.',
  'settings.saved': 'സേവ് ചെയ്തു',
  'settings.install': 'ഹോം സ്ക്രീനിൽ ചേർക്കുക',
  'settings.installBody': 'ഒരു ആപ്പ് പോലെ തുറക്കും, സൈൻ ഇൻ ചെയ്ത നിലയിൽ തുടരും.',
  'settings.installIOS': 'Safari-യിൽ Share ടാപ്പ് ചെയ്ത്, “Add to Home Screen” തിരഞ്ഞെടുക്കുക.',
  'settings.installBtn': 'Eat Recipe ചേർക്കുക',
  'install.later': 'ഇപ്പോൾ വേണ്ട',
  'install.android': 'ബ്രൗസർ മെനുവിൽ (⋮) “Install app” അല്ലെങ്കിൽ “Add to Home screen” ടാപ്പ് ചെയ്യുക.',
  'settings.privacy': 'സ്വകാര്യതാ നയം ↗',
  'settings.deletion': 'നിങ്ങളുടെ ഡാറ്റ എങ്ങനെ ഇല്ലാതാക്കുന്നു ↗',
  'settings.signOut': 'സൈൻ ഔട്ട്',
  'settings.delete': 'എന്റെ അക്കൗണ്ട് ഇല്ലാതാക്കുക',
  'settings.deleteConfirm': 'എല്ലാം ഇല്ലാതാക്കാൻ വീണ്ടും ടാപ്പ് ചെയ്യുക',
  'settings.deleteNote': 'നിങ്ങളുടെ ലൈബ്രറി, കുറിപ്പുകൾ, ആൽബങ്ങൾ, പാചക ചരിത്രം എന്നിവ എന്നേക്കുമായി ഇല്ലാതാകും.',
  'settings.deleteKeep': 'മറ്റുള്ളവർ സേവ് ചെയ്ത പാചകക്കുറിപ്പുകൾ അവർക്ക് ലഭ്യമായിരിക്കും.',
  'order.groceryTitle': '{app} ൽ ഓർഡർ ചെയ്യുക',
  'order.cartTitle': 'നിങ്ങളുടെ {app} കാർട്ട്',
  'order.connectTitle': 'നിങ്ങളുടെ {app} അക്കൗണ്ട് ബന്ധിപ്പിക്കുക',
  'order.connectBody': 'നിങ്ങളുടെ ഫോൺ നമ്പർ ഉപയോഗിച്ച് {app} ൽ സൈൻ ഇൻ ചെയ്യുന്നു. തുടർന്ന് Eat Recipe ഈ ലിസ്റ്റിൽ നിന്ന് നിങ്ങളുടെ {app} കാർട്ട് നിറയ്ക്കും; പണമടയ്ക്കൽ {app} ൽ.',
  'order.connect': '{app} ബന്ധിപ്പിക്കുക',
  'order.connectFailed': '{app} ബന്ധിപ്പിക്കൽ പൂർത്തിയായില്ല. ദയവായി വീണ്ടും ശ്രമിക്കുക.',
  'order.emptyList': 'നിങ്ങളുടെ പലചരക്ക് ലിസ്റ്റ് ശൂന്യമാണ്.',
  'order.finding': '{app} ൽ നിങ്ങളുടെ സാധനങ്ങൾ തിരയുന്നു…',
  'order.pickHint': 'ഓരോ സാധനത്തിനും പാക്ക് തിരഞ്ഞെടുക്കുക. വീട്ടിലുള്ള സാധാരണ സാധനങ്ങൾ ഒഴിവാക്കി.',
  'order.recipeNeeds': 'പാചകക്കുറിപ്പുകൾക്ക് വേണ്ടത് {q}',
  'order.pantry': 'സാധാരണ വീട്ടിലുണ്ടാകും',
  'order.notFound': '{app} ൽ കണ്ടെത്തിയില്ല',
  'order.pack': 'പാക്ക്',
  'order.quantity': 'അളവ്',
  'order.less': 'ഒന്ന് കുറവ്',
  'order.more': 'ഒന്ന് കൂടി',
  'order.build': 'എന്റെ {app} കാർട്ട് നിറയ്ക്കുക · {n} സാധനങ്ങൾ',
  'order.build_one': 'എന്റെ {app} കാർട്ട് നിറയ്ക്കുക · 1 സാധനം',
  'order.building': 'നിങ്ങളുടെ കാർട്ട് നിറയ്ക്കുന്നു…',
  'order.payInApp': 'വിലകൾ {app} യുടേതാണ്, ചെക്കൗട്ടിൽ മാറിയേക്കാം. ഡെലിവറി സമയവും പണമടയ്ക്കലും {app} ൽ തിരഞ്ഞെടുക്കുക.',
  'order.openToPay': 'പണമടയ്ക്കാൻ {app} തുറക്കുക',
  'order.cartReady': 'നിങ്ങളുടെ കാർട്ട് തയ്യാർ — ചെക്കൗട്ടിനായി {app} ആപ്പ് തുറക്കുക.',
  'order.editItems': 'സാധനങ്ങൾ മാറ്റുക',
  'food.title': '{app} ൽ ഓർഡർ ചെയ്യുക',
  'food.connectBody': 'നിങ്ങളുടെ ഫോൺ നമ്പർ ഉപയോഗിച്ച് {app} ൽ സൈൻ ഇൻ ചെയ്യുന്നു. Eat Recipe ഈ വിഭവം അടുത്ത് തിരഞ്ഞ്, നിങ്ങൾ സ്ഥിരീകരിച്ചതിന് ശേഷം മാത്രം ഓർഡർ ചെയ്യും.',
  'food.deliverTo': 'ഇവിടേക്ക് ഡെലിവറി',
  'food.address': 'വിലാസം',
  'food.change': 'മാറ്റുക',
  'food.noAddress': '{app} ൽ സേവ് ചെയ്ത വിലാസമില്ല. ആദ്യം {app} ആപ്പിൽ ചേർക്കുക.',
  'food.dish': 'വിഭവത്തിന്റെ പേര്',
  'food.search': 'തിരയുക',
  'food.none': 'ഇപ്പോൾ {app} ൽ അടുത്തുള്ള ഒരു റെസ്റ്റോറന്റിലും ഇത് ഇല്ല.',
  'food.soldOut': 'വിറ്റുതീർന്നു',
  'food.customizable': 'ഓപ്ഷനുകൾ വേണം — ഇത് {app} ആപ്പിൽ ഓർഡർ ചെയ്യുക',
  'food.review': 'ഓർഡർ കാണുക',
  'food.reviewTitle': 'നിങ്ങളുടെ ഓർഡർ കാണുക',
  'food.payWith': 'പണമടയ്ക്കൽ രീതി',
  'food.noPayment': 'ഇവിടെ ഈ ഓർഡറിന് {app} ഒരു പണമടയ്ക്കൽ രീതിയും നൽകുന്നില്ല.',
  'food.note': 'റെസ്റ്റോറന്റിനുള്ള കുറിപ്പ് (ഐച്ഛികം)',
  'food.notePlaceholder': 'എരിവ് കുറവ്, ഉള്ളി വേണ്ട…',
  'food.cancelNote': 'ഓർഡറുകൾ നേരിട്ട് റെസ്റ്റോറന്റിലേക്ക് പോകുന്നു. ക്യാഷ് ഓർഡറുകൾ ഇവിടെ റദ്ദാക്കാനാവില്ല; ആവശ്യമെങ്കിൽ {app} സപ്പോർട്ടുമായി ബന്ധപ്പെടുക.',
  'food.choosePayment': 'എങ്ങനെ പണമടയ്ക്കണമെന്ന് തിരഞ്ഞെടുക്കുക',
  'food.place': 'ഓർഡർ ചെയ്യുക · {total} · {method}',
  'food.placing': 'നിങ്ങളുടെ ഓർഡർ ചെയ്യുന്നു…',
  'food.doneTitle': 'നിങ്ങളുടെ ഓർഡർ',
  'food.placed': '{app} ഓർഡർ ചെയ്തു',
  'food.orderId': 'ഓർഡർ {id}',
  'food.eta': '{eta} ൽ എത്തും',
  'food.refresh': 'സ്ഥിതി പരിശോധിക്കുക',
  'food.payNow': 'നിങ്ങളുടെ UPI ആപ്പിൽ പണമടയ്ക്കുക',
  'food.payBody': 'പണമടച്ചാലുടൻ ഓർഡർ {app} ൽ രേഖപ്പെടുത്തും.',
  'food.openUPI': 'UPI ആപ്പ് തുറക്കുക',
  'food.waiting': 'പണമടയ്ക്കലിനായി കാത്തിരിക്കുന്നു…',
  'food.failed': 'ഓർഡർ നടന്നില്ല',
  'recipe.orderIt': 'ഉണ്ടാക്കാൻ തോന്നുന്നില്ലേ? {app} ൽ ഓർഡർ ചെയ്യുക',
  'grocery.orderOn': '{app} ൽ ഓർഡർ ചെയ്യുക',
  'settings.apps': 'ഓർഡർ ആപ്പുകൾ',
  'settings.appsHint': 'പലചരക്ക് ലിസ്റ്റിൽ നിന്ന് കാർട്ട് നിറയ്ക്കാനോ വിഭവം ഓർഡർ ചെയ്യാനോ ഒരു ആപ്പ് ബന്ധിപ്പിക്കുക.',
  'settings.connected': 'ബന്ധിപ്പിച്ചു',
  'settings.connect': 'ബന്ധിപ്പിക്കുക',
  'settings.disconnect': 'വിച്ഛേദിക്കുക',
  'settings.appConnected': '{app} ബന്ധിപ്പിച്ചു',
  'settings.appDisconnected': '{app} വിച്ഛേദിച്ചു',
  'settings.grocery': 'പലചരക്ക്',
  'settings.food': 'ഫുഡ് ഡെലിവറി',
  'apps.title': 'ഈ പലചരക്ക് ഓർഡർ ചെയ്യുക',
  'apps.sub': '{n} പാചകക്കുറിപ്പുകളിൽ നിന്ന്. ഓർഡർ ചെയ്യാൻ ആപ്പ് തിരഞ്ഞെടുക്കുക.',
  'apps.sub_one': '1 പാചകക്കുറിപ്പിൽ നിന്ന്. ഓർഡർ ചെയ്യാൻ ആപ്പ് തിരഞ്ഞെടുക്കുക.',
  'apps.none': 'ഈ സെർവറിൽ ഇതുവരെ പലചരക്ക് ആപ്പ് സജ്ജമാക്കിയിട്ടില്ല.',
  'apps.signIn': 'നിങ്ങളുടെ ഫോൺ നമ്പർ ഉപയോഗിച്ച് സൈൻ ഇൻ ചെയ്യുക',
  'apps.note': 'Eat Recipe ആപ്പിന്റെ കാർട്ട് നിറച്ച് അതിന്റെ സ്വന്തം വിലകൾ കാണിക്കും. നിങ്ങൾ സ്ഥിരീകരിക്കുന്നത് വരെ ഒന്നും ഓർഡർ ചെയ്യില്ല.',
  'soon.badge': 'ഉടൻ വരുന്നു',
  'soon.orderOn': '{apps}-ൽ ഓർഡർ',
  'soon.body': '{app} Eat Recipe അംഗീകരിച്ചാലുടൻ ഇവിടെ നിന്ന് ഓർഡർ ചെയ്യാം.',
  'grocery.orderAll': 'ഈ പലചരക്ക് ഓർഡർ ചെയ്യുക',
  'order.connectBody2': 'നിങ്ങളുടെ ഫോൺ നമ്പർ ഉപയോഗിച്ച് {app} ൽ സൈൻ ഇൻ ചെയ്യുന്നു. തുടർന്ന് Eat Recipe ഈ ലിസ്റ്റിൽ നിന്ന് കാർട്ട് ഉണ്ടാക്കി {app} യുടെ വിലകൾ കാണിക്കും; നിങ്ങൾ സ്ഥിരീകരിക്കുന്നത് വരെ ഒന്നും ഓർഡർ ചെയ്യില്ല.',
  'order.reviewN': 'ഓർഡർ കാണുക · {n} സാധനങ്ങൾ',
  'order.reviewN_one': 'ഓർഡർ കാണുക · 1 സാധനം',
  'order.notDeliverable': 'ഇപ്പോൾ {app} ന് ഈ വിലാസത്തിലേക്ക് ഈ കാർട്ട് ഡെലിവർ ചെയ്യാനാവില്ല.',
  'order.realOrder': 'ഇത് നിങ്ങളുടെ {app} കാർട്ടിലുള്ളവ മാറ്റിസ്ഥാപിക്കും. ഓർഡർ യഥാർത്ഥമാണ്: {app} ഡെലിവർ ചെയ്ത്, നിങ്ങൾ തിരഞ്ഞെടുത്ത രീതിയിൽ പണം ഈടാക്കും.',
  'order.payTitle': 'ഓർഡർ പൂർത്തിയാക്കാൻ പണമടയ്ക്കുക',
  'order.payNow': 'പണമടയ്ക്കൽ പേജ് തുറക്കുക',
  'order.finishInApp': '{app} ആപ്പിൽ പൂർത്തിയാക്കുക',
  'order.finishInAppNote': 'നിങ്ങളുടെ കാർട്ട് ഇതിനകം {app} ലുണ്ട്: അവിടെ കൂടുതൽ ചേർക്കാം, കൂപ്പൺ ഉപയോഗിക്കാം, പണമടയ്ക്കാം.',
  'order.cancelInApp': 'റദ്ദാക്കണോ? {app} ആപ്പ് തുറക്കുക (ഓർഡർ {id}). പണമടയ്ക്കാത്ത ഓർഡറുകൾ ഡെലിവർ ചെയ്യില്ല.',
  'order.pickedOf': '{total} ൽ {n} തിരഞ്ഞെടുത്തു',
  'order.basicsLeftOut': 'വീട്ടിലുള്ള സാധാരണ സാധനങ്ങൾ ഒഴിവാക്കി',
  'order.include': '{item} ഉൾപ്പെടുത്തുക',
  'order.otherPacks': 'മറ്റ് പാക്കുകൾ',
  'order.itemsFeesNext': '{n} സാധനങ്ങൾ · ഫീസ് അടുത്ത ഘട്ടത്തിൽ',
  'order.itemsFeesNext_one': '1 സാധനം · ഫീസ് അടുത്ത ഘട്ടത്തിൽ',
  'food.dishesNear': 'നിങ്ങളുടെ അടുത്ത് {n} വിഭവങ്ങൾ',
  'food.dishesNear_one': 'നിങ്ങളുടെ അടുത്ത് 1 വിഭവം',
  'food.add': 'ചേർക്കുക',
  'food.soldOutShort': 'തീർന്നു',
  'food.optionsInApp': 'ഓപ്ഷനുകൾ {app} ൽ',
  'food.oneItem': '{n} സാധനങ്ങൾ · {total}',
  'food.oneItem_one': '1 സാധനം · {total}',
  'order.payInApp2': 'ഈ ഓർഡറിന്റെ പണമടയ്ക്കൽ പൂർത്തിയാക്കാൻ {app} ആപ്പ് തുറക്കുക.',
  'order.checkFirst': 'വീണ്ടും ശ്രമിക്കുന്നതിന് മുമ്പ്, രണ്ട് തവണ ഓർഡർ ആകാതിരിക്കാൻ {app} ആപ്പിൽ നിങ്ങളുടെ ഓർഡറുകൾ പരിശോധിക്കുക.',

  'search.placeholder': 'tomato · rasam · dosa',
  'script.ta': 'തമിഴ്',
  'script.en': 'ഇംഗ്ലീഷ്',
  'script.tg': 'Tanglish',
  'cook.done': 'കഴിഞ്ഞു',
  'recipe.contentLang': 'പാചകക്കുറിപ്പുകൾ തമിഴ്, ഇംഗ്ലീഷ്, Tanglish എന്നിവയിൽ എഴുതുന്നു.',
  'auth.checking': 'നിങ്ങളുടെ ലിങ്ക് പരിശോധിക്കുന്നു…',
  'auth.isYou': 'ഇത് നിങ്ങളാണോ?',
  'auth.yourAccount': 'നിങ്ങളുടെ അക്കൗണ്ട്',
  'auth.linkFrom': 'ഈ ലിങ്ക് {h} യുമായുള്ള നിങ്ങളുടെ ചാറ്റിൽ നിന്നാണ്. ഇത് ഒരു തവണ മാത്രം പ്രവർത്തിക്കും, അതിനാൽ മറ്റാർക്കും ഇതുപയോഗിച്ച് നിങ്ങളുടെ ലൈബ്രറി തുറക്കാനാവില്ല.',
  'auth.continueAs': '{who} ആയി തുടരുക',
  'auth.notYou': 'നിങ്ങളല്ലേ? സ്വന്തം ലിങ്ക് നേടുക',
  'auth.opening': 'നിങ്ങളുടെ ലൈബ്രറി തുറക്കുന്നു…',
  'auth.used': 'ഈ ലിങ്ക് ഇതിനകം ഉപയോഗിച്ചു',
  'auth.usedBody': 'ഓരോ ലിങ്കും നിങ്ങളുടെ ലൈബ്രറി ഒരു തവണ, കുറച്ച് സമയത്തേക്ക് മാത്രം തുറക്കും. പുതിയത് നിമിഷങ്ങൾക്കുള്ളിൽ കിട്ടും.',
  'auth.stepOpen': '{h} യുമായുള്ള നിങ്ങളുടെ ചാറ്റ് തുറക്കുക',
  'auth.stepSend': '{w} അയച്ച് പുതിയ ലിങ്ക് ടാപ്പ് ചെയ്യുക',
  'auth.newLink': 'പുതിയ ലിങ്ക് നേടുക',
  'auth.safe': 'നിങ്ങൾ സേവ് ചെയ്ത പാചകക്കുറിപ്പുകൾ സുരക്ഷിതമാണ് — ഒന്നും നഷ്ടപ്പെട്ടില്ല.',
  'auth.checkFailed': 'നിങ്ങളുടെ ലിങ്ക് പരിശോധിക്കാനായില്ല',
  'auth.checkConn': 'ദയവായി കണക്ഷൻ പരിശോധിച്ച് വീണ്ടും ശ്രമിക്കുക.',
  'auth.hello': 'നമസ്കാരം,',
  'auth.friend': 'സുഹൃത്തേ',
  'auth.summaryEmpty': 'ഒരു പാചക റീൽ @eat.recipe ലേക്ക് ഷെയർ ചെയ്യൂ, അത് ഇവിടെ കാണാം.',
  'auth.summary': 'നിങ്ങളുടെ DM-ൽ നിന്ന് {n} പാചകക്കുറിപ്പുകൾ സേവ് ചെയ്തു.',
  'auth.summary_one': 'നിങ്ങളുടെ DM-ൽ നിന്ന് 1 പാചകക്കുറിപ്പ് സേവ് ചെയ്തു.',
  'auth.reading': '{n} ഇപ്പോഴും വായിക്കുന്നു.',
  'auth.reading_one': '1 ഇപ്പോഴും വായിക്കുന്നു.',
  'auth.installBody': 'ഒരു ആപ്പ് പോലെ തുറക്കും, സൈൻ ഇൻ ചെയ്ത നിലയിൽ തുടരും, കുറഞ്ഞ ഡാറ്റ.',
  'auth.openLibrary': 'എന്റെ ലൈബ്രറി തുറക്കുക',
  'signin.bubble': 'ഇതാ നിങ്ങളുടെ ഒറ്റത്തവണ ലിങ്ക്. ലൈബ്രറി തുറക്കാൻ ടാപ്പ് ചെയ്യുക →',
  'signin.title': 'നിങ്ങളുടെ പാചകക്കുറിപ്പുകൾ DM-ൽ കാത്തിരിക്കുന്നു',
  'signin.step1': 'Instagram-ൽ {h} തുറക്കുക',
  'signin.step2': '{w} എന്ന വാക്ക് അയയ്ക്കുക',
  'signin.step3': 'ഞങ്ങൾ അയയ്ക്കുന്ന ലിങ്ക് ടാപ്പ് ചെയ്യുക. പാസ്‌വേഡ് ഒരിക്കലും വേണ്ട.',
  'signin.message': '@eat.recipe ന് മെസേജ് ചെയ്യുക',
  'signin.have': 'ലിങ്ക് ഇതിനകം ഉണ്ടോ? ഈ ഫോണിൽ തുറന്നാൽ മതി.',
};
